<template>
  <svg
    width="16"
    height="29"
    viewBox="0 0 16 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.84512 27.8332C2.19429 28.4841 1.13896 28.4841 0.488125 27.8332C-0.162708 27.1824 -0.162708 26.1271 0.488125 25.4762L10.286 15.6784C10.9368 15.0276 10.9368 13.9723 10.286 13.3214L0.488127 3.52359C-0.162706 2.87276 -0.162706 1.81743 0.488127 1.16659C1.13896 0.515758 2.19429 0.515759 2.84513 1.16659L14.9999 13.3214C15.6508 13.9723 15.6508 15.0276 14.9999 15.6784L2.84512 27.8332Z"
      fill="#FF6347"
    />
  </svg>
</template>
